var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoutes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_x0020_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_763",
    "data-name": "Group 763"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_930",
    "data-name": "Rectangle 930",
    width: 26,
    height: 26,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762",
    transform: "translate(1.142 1.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    d: "M825.23,386.28h9.83a4.5,4.5,0,0,1,4.491,4.49h0a4.5,4.5,0,0,1-4.491,4.49H831.27",
    transform: "translate(-815.838 -383.402)",
    fill: "none",
    stroke: "#ebecff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    d: "M28.694,1523.67H24.811a4.5,4.5,0,0,0-4.491,4.49h0a4.5,4.5,0,0,0,4.491,4.49H37.637",
    transform: "translate(-20.32 -1511.81)",
    fill: "none",
    stroke: "#ebecff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    strokeDasharray: "1 2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    cx: 2.874,
    cy: 2.874,
    rx: 2.874,
    ry: 2.874,
    transform: "translate(17.963 17.965)",
    fill: "none",
    stroke: "#ebecff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_207",
    "data-name": "Ellipse 207",
    cx: 2.874,
    cy: 2.874,
    rx: 2.874,
    ry: 2.874,
    transform: "translate(8.999 8.986)",
    fill: "none",
    stroke: "#ebecff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    d: "M26.043,24.6,20.31,27.478,21.517,24.6,20.31,21.73Z",
    transform: "translate(-20.31 -21.73)",
    fill: "none",
    stroke: "#ebecff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutes);
export default __webpack_public_path__ + "static/media/routes.4ff0b763.svg";
export { ForwardRef as ReactComponent };